import { Competition } from 'shared/types/quotes';

export function getCompetitionRowKey(row: Competition) {
  return `${row.modelName}|${row.modelNumber}|${row.currentMarketPrice}`;
}
